import { render, staticRenderFns } from "./bankDetailsTop.vue?vue&type=template&id=7a1e60ba"
import script from "./bankDetailsTop.vue?vue&type=script&lang=js"
export * from "./bankDetailsTop.vue?vue&type=script&lang=js"
import style0 from "./bankDetailsTop.vue?vue&type=style&index=0&id=7a1e60ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports